import { Component } from '@grafikr/components';

export default Component((node, { onMounted }) => {
  const isSticky = node.dataset.sticky === 'true';
  const isTransparent = node.dataset.transparent === 'true';

  const transparencyController = () => {
    window.addEventListener(
      'scroll',
      () => {
        node.classList.toggle('header--transparent', window.scrollY <= 256);
      },
      { passive: true },
    );
  };

  const scrollController = () => {
    const SCROLL_THRESHOLD = 128;
    let lastScrollPosition = window.scrollY;

    window.addEventListener(
      'scroll',
      () => {
        node.classList.toggle(
          'header--scrolled',
          window.scrollY > SCROLL_THRESHOLD && window.scrollY > lastScrollPosition,
        );

        lastScrollPosition = window.scrollY;
      },
      {
        passive: true,
      },
    );
  };

  onMounted(() => {
    if (isTransparent) {
      transparencyController();
    }

    if (isSticky) {
      scrollController();
    }
  });
});
